import styled, { createGlobalStyle } from "styled-components"
import { maxWidth } from "utils"

export const ModalContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  min-height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 6;

  display: flex;
  align-items: center;
  justify-content: center;

  ${maxWidth.mobile`
    justify-content: center;

  `}

  /* scroll if modal exceeds page height */
  overflow: auto;

  aside {
    max-height: 100vh;
  }
`

export const BodyOverride = createGlobalStyle`
  body {
    overflow: hidden;
  }
`
